import { cdnService } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { StaticPageMixin } from '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let StaticPageHeaderComponent = class extends Mixins(StaticPageMixin) {
  get image() {
    if (!this.page || typeof this.page === "string" || !this.page.image) {
      return "";
    }
    return cdnService.getPageImageUrl(this.page.image);
  }
  get oneThird() {
    return this.variant === "one-third";
  }
  get oneFourth() {
    return this.variant === "one-fourth";
  }
  get topNav() {
    return this.variant === "top-nav";
  }
};
__decorateClass([
  Prop(Boolean)
], StaticPageHeaderComponent.prototype, "hideTitle", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageHeaderComponent.prototype, "hideImage", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageHeaderComponent.prototype, "hideDescription", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageHeaderComponent.prototype, "showContent", 2);
__decorateClass([
  Prop(Boolean)
], StaticPageHeaderComponent.prototype, "marketingBanner", 2);
__decorateClass([
  Prop(String)
], StaticPageHeaderComponent.prototype, "variant", 2);
StaticPageHeaderComponent = __decorateClass([
  Component({
    name: "static-page-header"
  })
], StaticPageHeaderComponent);

export default StaticPageHeaderComponent;
